import { Directive } from '@angular/core';

@Directive({
  selector: '[appImageLoad]',
})
export class ImageLoadDirective {
  constructor() {}
}
